import * as $ from 'jquery';

const testimonialListing = $('.acf-testimonial-listing__inner');
const swiperNavPrev = $('<div>', {'class': 'swiper-button-prev'});
const swiperNavNext = $('<div>', {'class': 'swiper-button-next'});

if (testimonialListing != null) {
	// add main swiper class
	testimonialListing.addClass('swiper-testimonial');
	// add swiper class to inner wrapper
	testimonialListing.find('.acf-testimonial-listing__blockWrapper').addClass('swiper-wrapper');
	// add swiper slide class to each cover block in testimonialListing
	testimonialListing.find('.acf-blockquote').each(function () {
		$(this).addClass('swiper-slide');
	});
	// add pagination
	testimonialListing.append([swiperNavPrev, swiperNavNext]);
}
